import PropTypes from "prop-types";

export default PropTypes.shape({
  id: PropTypes.string,
  accounts: PropTypes.arrayOf(PropTypes.string.isRequired),
  message: PropTypes.string,
  date: PropTypes.string,
  draftId: PropTypes.string,
  draftStatus: PropTypes.string,
  time: PropTypes.string,
  timezone: PropTypes.string,
  scraper: PropTypes.shape({
    link: PropTypes.string.isRequired,
    title: PropTypes.string,
    image: PropTypes.string,
    description: PropTypes.string,
  }),
  photos: PropTypes.arrayOf(
    PropTypes.shape({
      order: PropTypes.number,
      url: PropTypes.string.isRequired,
      thumbUrl: PropTypes.string.isRequired,
      dir: PropTypes.string.isRequired,
      fileName: PropTypes.string.isRequired,
      meta: PropTypes.shape({
        width: PropTypes.number,
        height: PropTypes.number,
      }),
    })
  ),
  videos: PropTypes.arrayOf(
    PropTypes.shape({
      order: PropTypes.number,
      url: PropTypes.string.isRequired,
      thumbUrl: PropTypes.string.isRequired,
      dir: PropTypes.string.isRequired,
      fileName: PropTypes.string.isRequired,
      meta: PropTypes.shape({
        width: PropTypes.number,
        height: PropTypes.number,
        duration: PropTypes.number,
      }),
      converted: PropTypes.bool, // only sent to the backend for new files
    })
  ),
  comments: PropTypes.arrayOf(
    PropTypes.shape({
      message: PropTypes.string.isRequired,
      delay: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    })
  ),
  shortlinksUtmData: PropTypes.shape({
    shortLinks: PropTypes.shape({
      [PropTypes.string]: PropTypes.shape({
        string: PropTypes.string.isRequired,
        short: PropTypes.string.isRequired,
        disabled: PropTypes.bool.isRequired,
      }),
    }),
    shortLinksEnabled: PropTypes.bool,
    utmEnabled: PropTypes.bool,
  }),
  additional: PropTypes.arrayOf(
    PropTypes.shape({
      source: PropTypes.string.isRequired,
      type: PropTypes.string.isRequired,
      [PropTypes.string]: PropTypes.string,
    })
  ),
  entitiesMap: PropTypes.arrayOf(
    PropTypes.shape({
      source: PropTypes.string.isRequired,
      type: PropTypes.string.isRequired,
      offset: PropTypes.number.isRequired,
      length: PropTypes.number.isRequired,
      [PropTypes.string]: PropTypes.string,
    })
  ),
});
